import { SelectHTMLAttributes } from "react";
import { LabeledInputComponent } from "./LabeledInputComponent";

export interface LabeledSelectProps {
  onChange(value: string | null): void;
  value: string | null;
  label: string;
  id: string;
  description?: string;
  options: { value: string; label?: string }[];
  placeholder?: string;
  inputProps?: SelectHTMLAttributes<HTMLSelectElement>;
}
export const LabeledSelect = ({
  onChange,
  value,
  label,
  id,
  description,
  options,
  placeholder,
  inputProps,
}: LabeledSelectProps) => (
  <LabeledInputComponent id={id} label={label} description={description}>
    <select
      onChange={(event) =>
        onChange(event.target.value === "" ? null : event.target.value)
      }
      value={value === null ? "" : value}
      {...inputProps}
    >
      {placeholder ? <option value="">{placeholder}</option> : null}
      {options.map(({ value, label }) => (
        <option key={value} value={value}>
          {label || value}
        </option>
      ))}
    </select>
  </LabeledInputComponent>
);